// Comprehensive error suppression utility
export const suppressResizeObserverErrors = () => {
  // Method 1: Override window.ResizeObserver
  if (typeof window !== 'undefined' && window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          requestAnimationFrame(() => {
            try {
              callback(entries, observer);
            } catch (e) {
              // Suppress ResizeObserver errors silently
              if (!e.message.includes('ResizeObserver')) {
                throw e;
              }
            }
          });
        });
      }
    };
  }

  // Method 2: Global error handler
  const errorHandler = (event) => {
    if (event.error && event.error.message && 
        (event.error.message.includes('ResizeObserver') ||
         event.message.includes('ResizeObserver'))) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return true;
    }
  };

  window.addEventListener('error', errorHandler, true);

  // Method 3: Unhandled rejection
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('ResizeObserver')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return true;
    }
  });

  return () => {
    window.removeEventListener('error', errorHandler, true);
  };
};
